import { render, staticRenderFns } from "./PeopleDetails.vue?vue&type=template&id=53e57596&"
import script from "./PeopleDetails.vue?vue&type=script&lang=js&"
export * from "./PeopleDetails.vue?vue&type=script&lang=js&"
import style0 from "./PeopleDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports